export default __webpack_public_path__ + "static/media/noFiles.98d8667e.gif";